import styled from 'styled-components';
import * as BORDER_RADIUS from '@upgrade/themes/constants/border-radius';
import Button from '../Button/styles';
import Text from '../Typography/Text';
import { fontSize } from '../Typography/mixins';
export const AlertTitle = styled(Text).attrs({
  size: 'sm',
  bold: true,
  marginBottom: 'xs',
  color: 'content'
})`
  display: block;
  &:last-child {
    margin-bottom: 0;
  }
`;
export const ContentContainer = styled.div`
  flex-grow: 1;
  color: ${props => props.theme.palette.contentWeak};
`;
export const IconContainer = styled.div`
  margin-right: 0.5rem;
`;
export const AlertContainer = styled.div`
  display: flex;
  align-items: flex-start;
  min-width: 100%;
  border-radius: ${props => BORDER_RADIUS[props.$borderRadius]};
  border: 1.5px solid ${props => props.$color};
  line-height: 1rem;
  padding: ${({
  $padded
}) => $padded ? '1rem' : 'none'};
  background-color: ${props => props.theme.palette.backgroundPrimary};
  p {
    ${fontSize('xs')};
    margin-bottom: 0.5rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  ${Button} {
    ${fontSize('sm')};
  }
`;
//# sourceMappingURL=styles.js.map